import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registers the service worker, enabling offline caching AND push
// notifications. Without this call, service-worker.js exists as a file
// but never actually activates — none of its code runs.
serviceWorkerRegistration.register();